import React from 'react';
import { withStyles, IconButton, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = {
  icon: { color: '#838287', transform: 'scale(0.95)' },
  button: {
    padding: 0,
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
};

const IconsButton = ({
  icon: Icon,
  classes,
  handleClick,
  size,
  style,
  disabled,
  tooltip,
  disabledTooltip,
}) => {
  const title = disabled && disabledTooltip ? disabledTooltip : tooltip;

  const button = (
    <IconButton
      className={classes.button}
      onClick={handleClick}
      disabled={disabled}
    >
      <Icon
        className={classes.icon}
        style={style ? style : {}}
        fontSize={size || 'medium'}
      />
    </IconButton>
  );

  // If no tooltip provided, render plain button
  if (!title) {
    return button;
  }

  // Wrap in span so tooltip still works when button is disabled
  return (
    <Tooltip
      title={title}
      placement="top"
      arrow
      disableFocusListener
      disableTouchListener
    >
      <span>{button}</span>
    </Tooltip>
  );
};

IconsButton.propTypes = {
  icon: PropTypes.any.isRequired,
  handleClick: PropTypes.func,
  size: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  disabledTooltip: PropTypes.string,
};

export default withStyles(styles as any, { withTheme: true })(IconsButton);
